<template>
  <div>
    <!-- main header -->
    <!--    <main-header></main-header>-->

    <v-container class="overflow-y-auto" style="position: relative">
      <!-- main widget ('master' vs 'emp') 권한을 사용하지 않아 emp 사용안함-->
      <master-main v-if="authGubun === 'master'" v-bind:authGubun="authGubun" />
      <!--emp-main v-else v-bind:authGubun="authGubun" /-->

      <!-- main floating button (신청서메뉴)>
      <main-floating-btn v-if="GET_APPL_MENU_USE_YN" /-->
    </v-container>
  </div>
</template>

<script>
/* 메인 */
//import MainHeader from '@/components/common/MainHeader.vue';
// import MainFloatingBtn from '@/components/main/MainFloatingBtn.vue'; ** 메인화면에서 사용안하기로 함
import MasterMain from '@/components/main/mainWidgetList/MasterMain.vue';
// import EmpMain from '@/components/main/mainWidgetList/EmpMain.vue';

import { mapGetters } from 'vuex';
import routerConstants from '@/const/routerConstants';

export default {
  data: () => ({
    authGubun: 'emp', // 권한구분 (emp:직원 / master:임원,조직장)
    options: '',
    fileList: '',
  }),

  computed: {
    ...mapGetters(['GET_USER_DATA']),
    ...mapGetters('MENU', ['GET_APPL_MENU_USE_YN']),
  },

  methods: {
    /* 사용자 권한체크 */
    checkUserAuth() {
      // console.log('MainView checkUserAuth');
      // console.log('GET_USER_DATA.authGroup : ' + this.GET_USER_DATA.authGroup);
      /*
      const filterList = this.GET_USER_DATA.authGroup.filter(
        authGroupCd => authGroupCd == '20' || authGroupCd == '10',
      );
      */
      const filterList = this.GET_USER_DATA.authGroup;

      if (filterList != '' || this.GET_USER_DATA.orgChiefYn == 'Y') {
        this.authGubun = 'master'; // 조직장, 임원
      } else {
        this.authGubun = 'emp'; // 직원
      }
      // console.log('this.authGroup : ' + this.authGubun);
    },
  },

  created() {
    // console.log('MainView.vue');
    // console.log('GET_USER_DATA : ' + JSON.stringify(this.GET_USER_DATA));
    if (
      this.GET_USER_DATA.ssnSabun == undefined ||
      this.GET_USER_DATA.ssnSabun == null ||
      this.GET_USER_DATA.ssnSabun == '' ||
      this.GET_USER_DATA.authGroup == undefined
    ) {
      this.$router.push(routerConstants.Error);
    } else {
      this.checkUserAuth();
    }
  },

  mounted() {
    // bottom-navigation 메뉴항목에서 뒤로가기로 메인화면으로 이동시 active 문제로 인해서 강제설정
    // this.$parent.$parent.$refs.rBottomNav.activeValue = 'main';
  },

  components: {
    //MainHeader,
    //MainFloatingBtn,
    MasterMain,
    //EmpMain,
  },
};
// $(document).on('click', '#fileListId', function (event, param) {
//   console.dir(param);
// });
</script>
<!--, MasterMain-->

<style scoped>
.main-contents {
  background-image: url('../../assets/img/main_top_bg.png');
  background-position: top;
  background-size: contain;
}
</style>
